import React, { useEffect, useState, useRef } from 'react';
import { Box, Stack, Button, Typography, AppBar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DelegonMainLogoWhite from '../../website/assets/Delegon_Main_Logo_WHITE.png';

import { paths, ROOT_PATHS } from 'routes';
import { IconWrapper } from 'components/Icon';
import { BuyerSearch } from './BuyerSearch';
import { LocalizedLink } from './LocalizedLink';
import { LanguageSwitcher } from './LanguageSwitcher';

export const MobileMenu = ({menuItems, onClose}) => {
  const { t } = useTranslation();
  const mobileOnly = [
    { label: t('website:common.nav.login'), value: "login", path: paths.auth.login },
    { label: t('website:common.nav.signUpFree'), value: "register", path: paths.auth.register }
  ];
  const mobileMenu = [...menuItems, ...mobileOnly];

  return (
    <Stack
      sx={{
        height: "100dvh",
        px: 1,
        boxSizing: "border-box",
        width: 1,
        backgroundColor: "background.primary",
        position: "fixed",
        right: 0,
        top: 0,
        zIndex: 10,
        display: {xs: "flex", md: "none"},
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Stack
        width={1}
        height={70}
        flexShrink={0}
        display={"flex"}
        direction={"row"}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          px: 3,
          boxSizing: "border-box"
        }}
      >
        <Box
          // sx={{
          //   '.small-logo': { mt: "22px" },
          // }}
          component={LocalizedLink}
          to={ROOT_PATHS.WEBSITE}
          onClick={() => onClose()}
        >
          <img
            className="small-logo"
            src={DelegonMainLogoWhite}
            alt={'Delegon'}
            loading="lazy"
            style={{
              width: 150,
              flexShrink: 0,
            }}
          />
        </Box>
        <Box display={"flex"} height={35} onClick={onClose} sx= {{mr: "-7.63px"}}>
          <IconWrapper
            icon="xMark"
            sx={{
              height: 35,
              width: 35,
              svg: {
                color: "white",
                stroke: 'white',
                width: 35,
                height: 35,
              },
            }}
          />
        </Box>
      </Stack>
      <Stack
        display={"flex"}
        direction={"column"}
        gap={4.5}
        sx={{
          flex: 1,
          minHeight: 0,
          alignItems: "start",
          justifyContent: "flex-start",
          overflowY: "auto",
          overflowX: "hidden",
          WebkitOverflowScrolling: "touch",
          "& > div > a": {
            textDecoration: "none",
            color: "#fff",
            fontWeight: 400,
            fontSize: "1rem",
            lineHeight: 1.5,
          },
          boxSizing: "border-box",
          px: 3,
          paddingBottom: "calc(24px + env(safe-area-inset-bottom, 0px))",
        }}
      >
        {mobileMenu.map((item) => (
          <Box
            gap={1}
            key={item.value}
            sx={{
              height: 32,
              position: "relative",
              "&:hover": {
                "&::after": {
                  width: "50%",
                },
              },
            }}
          >
            <Typography
              key={item.value}
              component={LocalizedLink}
              to={item.path}
              onClick={() => onClose()}
            >
              {item.label}
            </Typography>
          </Box>
        ))}
        <LanguageSwitcher sx={{ color: '#fff' }} />
      </Stack>
    </Stack>
  )
}